import useSWR from 'swr';
import { customSWRConfig } from '../../model/types';
import { endUserPublicFetcher, fetcherWithToken } from '../../utils/fetchers';
import { nonNullishValue } from '../../utils/helpers';
import useSWRCacheKeys, { usePublicApiSWRCacheKeys } from '../useSWRCacheKeys';

export default function useFieldOptionsByIds(
    fieldKey: string,
    optionIds: string,
    isPublic: boolean = false,
    config: customSWRConfig = {}
) {
    const keys = useSWRCacheKeys(optionIds && fieldKey ? `/field-values/${fieldKey}/options?ids=${optionIds}` : null);
    const publicKeys = usePublicApiSWRCacheKeys(
        optionIds && fieldKey ? `/field-values/${fieldKey}/options?ids=${optionIds}` : null
    );
    const isKeyExists = nonNullishValue(keys) || nonNullishValue(publicKeys);
    const isAbleToMakeRequest = nonNullishValue(optionIds) && optionIds?.length > 0 && isKeyExists;

    return useSWR(
        isAbleToMakeRequest ? (isPublic ? publicKeys : keys) : null,
        isPublic ? endUserPublicFetcher : fetcherWithToken,
        { ...config }
    );
}
